export class ReplaceEmptyStringsWithNull {
  /*
   * Replaces empty strings with null
   */
  public static clean<T>(data: T): T {
    const cleaned: any = { ...data };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === '') {
        cleaned[key] = null;
      }
    });
    return cleaned as T;
  }
}
